module.exports = __webpack_public_path__ + "static/fonts/jura-latin.2623197.woff2";